import * as React from "react";
import { type ToasterToast } from "./types";

export interface ToastContextType {
  state: ToasterToast[];
  setState: React.Dispatch<React.SetStateAction<ToasterToast[]>>;
}

export const ToastContext = React.createContext<ToastContextType | undefined>(undefined);
